module.exports = __webpack_public_path__ + "static/media/BMODE_30_10.bc632af5.jpg";